import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { supabase } from '../../lib/supabase'
import { useAuth } from '../../lib/AuthContext'
import { Label, Msg, StyledInput, PrivacyPicker } from '../../components/Leagues/ui'
import GradientButton from '../../components/GradientButton'
import Sheet from './Sheet'

export default function ModaleCreaLega({ visible, userId, onClose, onSuccess }) {
  const { t } = useTranslation()
  const { competitionId } = useAuth()
  const [name, setName] = useState('')
  const [isPublic, setIsPublic] = useState(true)
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [err, setErr] = useState('')

  const handleCreate = async () => {
    if (!name.trim()) { setErr(t('league.err_name')); return }
    if (!isPublic && !password.trim()) { setErr(t('league.err_password')); return }
    setLoading(true); setErr('')
    try {
      const { data, error } = await supabase.rpc('fn_create_league', {
        p_id_user: userId, p_name: name.trim(), p_is_public: isPublic,
        p_password: isPublic ? null : password.trim(), p_id_competition: competitionId,
      })
      if (error) throw error
      const result = data?.[0]
      if (!result?.out_id_league) throw new Error(t('league.err_creation'))
      onSuccess(result.out_id_league)
    } catch (e) { setErr(e.message) } finally { setLoading(false) }
  }

  return (
    <Sheet visible={visible} title={t('league.create_title')} onClose={onClose}
      footer={<GradientButton onPress={handleCreate} loading={loading} style={{ width: '100%' }}>{t('league.create')}</GradientButton>}
    >
      <Label>{t('profile.nick_title')}</Label>
      <StyledInput value={name} onChangeText={setName} placeholder={t('league.create_name_placeholder')}
      />
      <Label>{t('league.privacy')}</Label>
      <PrivacyPicker isPublic={isPublic} onSelect={setIsPublic} />
      {!isPublic && <StyledInput value={password} onChangeText={setPassword} placeholder={t('league.create_pwd_placeholder')} secureTextEntry />}
      {err ? <Msg type="error" text={err} /> : null}
    </Sheet>
  )
}
